export const SLOT_STATE = {
    HIGHLIGHTED: 'highlighted',
};
//# sourceMappingURL=constants.js.map